import React from 'react';
import styled from 'styled-components';

import { Selector, MultiSelector, TextField, Button } from 'components';
import { TextInput } from 'features'
import { FaPlus, FaTimes } from 'react-icons/fa';

const defaultStyle = {
    backgroundColor: 'var(--primary-color)',
    fieldColor: 'var(--secondary-color)',
    margin: '0.5rem 0 0 0'
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0.5rem 0.75rem;
    border-radius: 5px;
    background-color: ${props => props.styles.backgroundColor};
    margin: ${props => props.styles.margin};
    border-width: 2px;
    border-style: solid;
    border-color: ${props => props.error ? 'var(--error-color)' : 'transparent'};
`

const Row = styled.div`
    display: grid;
    grid-template-columns: 27% 27% 1fr min-content;
    grid-column-gap: 0.5rem;
    align-items: center;
    margin: ${props => props.margin || '0.5rem 0 0 0'};
    overflow: hidden;
`

const Label = styled.div`
    font-size: 0.8rem;
    font-weight: bold;
`

const Error = styled.div`
    font-size: 0.8rem;
    color: var(--error-color);
    margin-left: 0.2rem;
    width: max-content;
    :before {
        content: '*'
    }
`


const operatorOptions = {
    'e': {
        title: 'Equals',
        value: 'e'
    },
    'ne': {
        title: 'Not equals',
        value: 'ne'
    },
    'in': {
        title: 'Includes',
        value: 'in'
    },
    'ni': {
        title: 'Not in',
        value: 'ni'
    },
    // 'gt': {
    //     title: '>',
    //     value: 'gt'
    // },
    // 'gte': {
    //     title: '>=',
    //     value: 'gte'
    // },
    // 'lt': {
    //     title: '<',
    //     value: 'lt'
    // },
    // 'lte': {
    //     title: '<=',
    //     value: 'lte'
    // },
}

const selectorStyle = {
    backgroundColor: 'var(--secondary-color)',
    secondaryColor: 'var(--secondary-accent-color)',
    margin: 0,
    fontSize: '0.8rem',
    labelSize: '0.7rem'
}

const textStyle = {
    fontSize: '0.8rem',
    labelSize: '0.7rem',
    backgroundColor: 'var(--secondary-color)',
    secondaryColor: 'var(--secondary-accent-color)',
    margin: 0,
}

const iconStyle = {
    backgroundColor: 'var(--primary-color)',
    boxShadowColor: 'transparent',
    margin: 0,
    width: '1rem',
    height: '1rem',
    padding: '0.5rem'
}

const ConditionalInput = props => {
    const {
        value,
        options,
        onSubmit,
        onEdit,
        styles,
        error,
        errors,
        label,
        refreshOptions
    } = props;
    const updatedStyle = Object.assign({}, defaultStyle, styles)

    const onSelect = (input, index, type) => {
        let rowValue = value[index]
        rowValue[type] = input
        let updatedValue = [...value]
        updatedValue[index] = rowValue
        onEdit && onEdit(updatedValue)
        // console.log({value,index, type, updatedValue})
    }

    const addRow = () => {
        let updatedValue = [...value]
        updatedValue.push({ option: null, operator: null, value: null })
        onEdit && onEdit(updatedValue)
    }

    const removeRow = (index) => {
        let updatedValue = [...value]
        updatedValue.splice(index,1)
        onEdit && onEdit(updatedValue)
    }

    const getRows = () => {
        let blocks = []
        value.map((row,index) => {
            blocks.push(
                <Row>
                    <Selector value={row['option']} styles={selectorStyle} placeholder='Column'
                        onSelect={(v) => onSelect(v, index, 'option')} 
                        options={options} refreshOptions={refreshOptions}
                        error={errors[index] && errors[index]['option']}/>
                    <Selector value={row['operator']} styles={selectorStyle} placeholder='Operator'
                        onSelect={(v) => onSelect(v, index, 'operator')} 
                        options={operatorOptions} 
                        error={errors[index] && errors[index]['operator']}/>
                    {['in','ni'].includes(row['operator'] && row['operator']['value']) ? 
                    <MultiSelector selected={row['value'] || []} styles={selectorStyle} placeholder='Input'
                        onSelect={(v) => onSelect(v, index, 'value')}
                        error={errors[index] && errors[index]['value']}/>
                    : <TextInput value={row['value']} styles={textStyle} placeholder='Input' addDelay
                        onChange={(v) => onSelect(v, index, 'value')} 
                        error={errors[index] && errors[index]['value']}/>}
                    <Button icon={<FaTimes/>} onSelect={() => removeRow(index)} styles={{...iconStyle, padding: '0.2rem'}}/>
                </Row>
            )
        })
        return blocks
    }

    return (
        <Container styles={updatedStyle} error={error}>
            {/* <Label>{label || 'Conditions'}</Label> */}
            <Row margin='0 0 0.2rem 0'>
                <Label styles={updatedStyle}>{label || 'Conditions'}</Label>
                {error && <Error>{error}</Error>}
            </Row>
            {getRows()}
            <Button icon={<FaPlus/>} onSelect={addRow} styles={{...iconStyle, margin: '0.25rem 0 0 0'}}/>
        </Container>
    )
}

export default ConditionalInput;